import {NgModule} from "@angular/core";
import {HistoryComponent} from "./history/history.component";
import {RouterModule} from "@angular/router";
import {MasseComponent} from "./masse/masse.component";
import {ReportingComponent} from "./reporting/reporting.component";

@NgModule({
  imports: [RouterModule.forChild([
    {
      path: 'injections',
      children: [
        {
          path: '',
          component: HistoryComponent
        },
        {
          path: 'hist',
          component: HistoryComponent
        },
        {
          path: 'mass',
          component: MasseComponent
        },
        {
          path: 'reporting',
          component: ReportingComponent
        }
      ]
    }
  ])],
  exports: [RouterModule],
  declarations: []
})
export class RoutingModule {

}



// WEBPACK FOOTER //
// ./src/app/modules/injection/injection.routing.ts